import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';
import { EICFTemplatesApi } from '../../../apis/EICFApi/EICFTemplatesApi.ts';
import { IEICFEscalationConfig } from '../EICFTemplate.ts';

interface PutEscalationConfigVars {
    facilityId: number;
    config: IEICFEscalationConfig;
}

export function usePutEscalationConfigForFacility() {
    const queryClient = useQueryClient();
    const { t } = useTranslation();
    return useMutation<void, AppMedError, PutEscalationConfigVars>({
        mutationKey: [QueryKeys.eicfEscalationConfig, 'put'],
        mutationFn: ({ facilityId, config }) =>
            EICFTemplatesApi.setEscalationConfig(facilityId, config),
        onSuccess: (_data, vars) => {
            queryClient.invalidateQueries({
                queryKey: [QueryKeys.eicfEscalationConfig, vars.facilityId],
            });
            notifications.show({
                color: 'green',
                message: t('eicf.admin.escalationConfigSaved'),
            });
        },
        onError: (err) => {
            notifications.show({ color: 'red', message: err.message });
        },
    });
}
